<input class="search" [value]="value" (input)="update.emit($any($event.target)?.value || '')"
  data-testid="context-menu-search-input" />
